// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"31dd2824","879":"5a927311"}[chunkId] + ".chunk.js";
};